<template>
<div class="chapter">
<div class="inner_page">
<p class="toch">CONTENTS</p>
<p class="toc1"><a href="#/Text/edpreface">EDITORIAL PREFACE</a></p>
<p class="toc1"> </p>
<p class="toc1"><a href="#/Text/Section0001">CHAPTER 1 - RAPE OF THE BUBBLE</a></p>
<p class="toc1"><a href="#/Text/Section0002">CHAPTER 2 - FAITH AND SPIRIT</a></p>
<p class="toc1"><a href="#/Text/Section0003">CHAPTER 3 - HARD CHOICE</a></p>
<p class="toc1"><a href="#/Text/Section0004">CHAPTER 4 - FLIGHT INTO VACUUM</a></p>
<p class="toc1"><span href="#/Text/Section0005" title="Link target outside of Sample">CHAPTER 5 - FIGHT FOR LIFE</span></p>
<p class="toc1"><span href="#/Text/Section0006" title="Link target outside of Sample">CHAPTER 6 - BUBBLE, BUBBLE</span></p>
<p class="toc1"><span href="#/Text/Section0007" title="Link target outside of Sample">CHAPTER 7 - BETRAYAL</span></p>
<p class="toc1"><span href="#/Text/Section0008" title="Link target outside of Sample">CHAPTER 8 - ADJUSTMENT</span></p>
<p class="toc1"><span href="#/Text/Section0009" title="Link target outside of Sample">CHAPTER 9 - MASSACRE</span></p>
<p class="toc1"><span href="#/Text/Section0010" title="Link target outside of Sample">CHAPTER 10 - TO LOVE AND BE LOVED</span></p>
<p class="toc1"><span href="#/Text/Section0011" title="Link target outside of Sample">CHAPTER 11 - SACRIFICE</span></p>
<p class="toc1"><span href="#/Text/Section0012" title="Link target outside of Sample">CHAPTER 12 - FOOD</span></p>
<p class="toc1"><span href="#/Text/Section0013" title="Link target outside of Sample">CHAPTER 13 - REFUGEES’ WELCOME</span></p>
<p class="toc1"><span href="#/Text/Section0014" title="Link target outside of Sample">CHAPTER 14 - HELL PLANET</span></p>
<p class="toc1"><span href="#/Text/Section0015" title="Link target outside of Sample">CHAPTER 15 - WHEN WILL IT END?</span></p>
<p class="toc1"><span href="#/Text/Section0016" title="Link target outside of Sample">CHAPTER 16 - VIOLATION OF TRUST</span></p>
<p class="toc1"><span href="#/Text/Section0017" title="Link target outside of Sample">CHAPTER 17 - FEMALE MYSTIQUE</span></p>
<p class="toc1"><span href="#/Text/Section0018" title="Link target outside of Sample">CHAPTER 18 - PIRATE TREASURE</span></p>
<p class="toc1"><span href="#/Text/Section0019" title="Link target outside of Sample">CHAPTER 19 - THE FINAL RAID</span></p>
<p class="toc1"><span href="#/Text/Section0020" title="Link target outside of Sample">CHAPTER 20 - SALVATION</span></p>
<p class="toc1"> </p>
<p class="toc1"><span href="#/Text/edepilogue" title="Link target outside of Sample">EDITORIAL EPILOG</span></p>
<p class="toc1"><span href="#/Text/Preview" title="Link target outside of Sample">PREVIEW: <i>MERCENARY</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3f811240